import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { GetFinancialStatementMonthState, GetFinancialStatementMonthTypes } from './types';

const initialState: GetFinancialStatementMonthState = {
    status: HttpRequestStatus.NOOP,
    financialStatementMonth: undefined,
    error: undefined,
};

const reducer: Reducer<GetFinancialStatementMonthState> = (state = initialState, action): GetFinancialStatementMonthState => {
    switch (action.type) {
        case GetFinancialStatementMonthTypes.GET_FINANCIAL_STATEMENT_MONTH_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, error: undefined };
        }
        case GetFinancialStatementMonthTypes.GET_FINANCIAL_STATEMENT_MONTH_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, financialStatementMonth: action.payload, error: undefined };
        }
        case GetFinancialStatementMonthTypes.GET_FINANCIAL_STATEMENT_MONTH_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case GetFinancialStatementMonthTypes.GET_FINANCIAL_STATEMENT_MONTH_RESET_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export { reducer as getFinancialStatementMonthReducer };
